import React from 'react'
import {useAppHeaderLoginBtnStyles} from './app-header-login.styles'

export const AppHeaderLoginBtn: React.FC = (): React.ReactElement => {
  const classes = useAppHeaderLoginBtnStyles()
  return <button className={classes.loginBtn}>
    Login
  </button>
}
